<div class="stock-distribute__container">
    <div class="stock-distribute__no-data__container">
        <i class="stock-distribute__no-data__container__icon fa-light fa-box"></i>
        <h5>Scan or type a barcode to start stock distributing</h5>
    </div>
</div>